import * as Sentry from '@sentry/react';
import { config } from './config';

/**
 * Sentry is the only observability layer (no SNS/CloudWatch-alarm/Chatbot chain).
 * DSN/stage/release come from the server-injected runtime config (config.ts), so
 * they are NOT baked into the bundle — the image is identical across environments.
 * Absent DSN = no-op (local dev). Source maps are uploaded to Sentry in the pipeline.
 */
export function initSentry() {
  if (!config.sentryDsn) return;
  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.stage,
    release: config.release,
    tracesSampleRate: 0.1,
  });
}
